import api from "./api";
const svc = {
  listar:        (p={}) => { const qs=new URLSearchParams(Object.entries(p).filter(([,v])=>v!==""&&v!==undefined)); return api("GET",`/reservas?${qs}`); },
  buscarPorId:   id     => api("GET",`/reservas/${id}`),
  criar:         data   => api("POST","/reservas",data),
  confirmar:     id     => api("PATCH",`/reservas/${id}/confirmar`,{}),
  marcarPaga:    id     => api("PATCH",`/reservas/${id}/pagar`,{}),
  realizar:      id     => api("PATCH",`/reservas/${id}/realizar`,{}),
  cancelar:      (id,data) => api("PATCH",`/reservas/${id}/cancelar`,data),
  devolverCaucao:(id,data) => api("PATCH",`/reservas/${id}/devolver-caucao`,data),
  calendario:    (idArea,mes) => api("GET",`/reservas/calendario?idArea=${idArea}&mes=${mes}`),
  pendentesCount:(idCondominio) => api("GET",`/reservas/pendentes-count?idCondominio=${idCondominio||""}`),
};
export default svc;
